module.exports = __webpack_public_path__ + "static/media/giftCard.19181c8f.png";